export interface DimensionMappingConfig<Data, Visualization> {
	data: Data;
	visualizations: Visualization[];
}
